import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/ui/button";

interface CancelBatchModalProps {
  isOpen: boolean;
  isCanceling: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const CancelBatchModal: React.FC<CancelBatchModalProps> = ({
  isOpen,
  isCanceling,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-lg p-6 w-[500px] bg-white dark:bg-slate-800 shadow-[0_10px_25px_rgba(0,0,0,.3)] outline-none"
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="fixed inset-0 bg-black/30 z-[9999]"
    >
      <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
        Cancel Batch
      </h3>
      <p className="mt-3 text-sm text-gray-600 dark:text-gray-400">
        Are you sure you want to cancel this batch?
        <br />
        <br />
        Note: Once canceled, the batch cannot be reactivated.
      </p>

      <div className="mt-6 flex justify-end space-x-3">
        <button
          className="inline-flex justify-center rounded-md bg-white dark:bg-slate-700 px-3 py-2 text-sm font-semibold text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-slate-600 hover:bg-gray-50 dark:hover:bg-slate-600"
          onClick={onClose}
          type="button"
        >
          Keep batch running
        </button>

        <Button
          className="bg-red-700 text-white hover:bg-red-800"
          disabled={isCanceling}
          onClick={onConfirm}
          type="button"
          variant="default"
        >
          {isCanceling ? "Canceling..." : "Yes, cancel batch"}
        </Button>
      </div>
    </Modal>
  );
};

export default CancelBatchModal;
